
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
// import moment from 'moment';
import CarService from '@/services/car.service';


@Component({
  filters: {
    payTimeFormat(time: string) {
      return time.startsWith('0000') ? null : time;
    },
  },
})
export default class OrderDrawer extends Vue {
  @lazyInject(OrderService)
  orderService!: OrderService;

  @lazyInject(CarService)
  carService!: CarService;

  visible = false;

  listData: any = {};

  async init(val: any) {
    const param: any = {
      order_no: val,
    };
    const data = await this.carService.auditEditShopOrder(param) as any;
    if (data) {
      this.listData = data?.list;
      this.visible = true;
    }
  }

  onClose() {
    this.visible = false;
  }
}
